import { Skeleton } from 'antd';
export default function WaterLevelSkeleton() {
    return <div className="analytics-metric" role="status" aria-label="Loading fuel totals">
        <Skeleton active={false} title={{ width: '45%' }} paragraph={{ rows: 1, width: '70%' }} />
    </div>;
}
